<!--
  ~ Copyright © 2018 DV Bern AG, Switzerland
  ~
  ~ Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
  ~ geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
  ~ insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
  ~ elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
  ~ Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
  -->
<div matRipple class="elohn-item"
     [@activeTransitionItem]="isActive"
     [attr.aria-pressed]="isActive"
     role="button"
     tabindex="0"
     (click)="onClick($event)"
     (focus)="showOperations()"
     (mouseenter)="showOperations()"
     (focusout)="hideOperations()"
     (mouseout)="hideOperations()"
     (keypress)="onKeypress($event)"
>
    <div class="elohn-item-icon-container">
        <ng-container *ngTemplateOutlet="icon"></ng-container>

        <ng-template #icon>
            <div [@activeTransitionItemIcon]="hasIconAnimation && isActive && !!iconTemplate" class="elohn-item-icon">
                <ng-container *ngIf="iconTemplate" [ngTemplateOutlet]="iconTemplate"></ng-container>
            </div>
        </ng-template>
    </div>

    <div class="elohn-item-label">
        <ng-container *ngIf="nameTemplate" [ngTemplateOutlet]="nameTemplate"></ng-container>
    </div>

    <div class="elohn-item-operation" *ngIf="canEdit">
        <button mat-icon-button
                i18n-matTooltip="@@arbeitNehmer.bearbeiten"
                matTooltip="Mitarbeiter {{displayName}} bearbeiten"
                (focusin)="showOperations()"
                (click)="onEdit($event)">
            <mat-icon class="elohn-item-operation-icon"
                      aria-label="bearbeiten"
                      i18n-aria-label="@@global.edit">
                edit
            </mat-icon>
        </button>
    </div>

    <div class="elohn-item-operation" *ngIf="canDelete">
        <!-- trick because select translations are not supported on attributes -->
        <span style="display:none;" i18n='@@arbeitNehmer.loeschen' #translatedDeleteMatTooltip>{mode, select, arbeitNehmer {Mitarbeiter {{displayName}} löschen} lohnausweis {Lohnausweis {{displayName}} löschen} other {löschen}}</span>
        <button mat-icon-button
                [matTooltip]="translatedDeleteMatTooltip.textContent || ''"
                (focusin)="showOperations()"
                (click)="onDelete($event)">
            <mat-icon class="elohn-item-operation-icon"
                      aria-label="löschen"
                      i18n-aria-label="@@global.delete">
                delete
            </mat-icon>
        </button>
    </div>
</div>
